import { useEffect } from 'react'

export type ThemeValue = 'dark' | 'light' | 'system'

/**
 * 帳場 Indigo(family-design)はライトテーマのみ。保存済み設定・OS 設定に関係なく常にライトにする。
 * （index.html の起動スクリプトでも最初の描画前に dark クラスを外している）
 * 引数は互換のため残している。
 */
export function applyTheme(_theme?: ThemeValue): void {
  document.documentElement.classList.remove('dark')
}

export function useTheme(theme: ThemeValue | undefined): void {
  useEffect(() => {
    if (!theme) return

    applyTheme(theme)
    localStorage.setItem('theme', theme)
  }, [theme])
}
